import { render, staticRenderFns } from "./versand.vue?vue&type=template&id=fa602496&scoped=true&"
import script from "./versand.vue?vue&type=script&lang=js&"
export * from "./versand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa602496",
  null
  
)

export default component.exports